import React, { useRef, useEffect } from "react";
import injectSheet from "react-jss";
import FileList from "./FileList";
import {
  useFileSize,
  MAX_ATTACHMENT_SIZE
} from "providers/FileSizeProvider/FileSizeProvider";
import { IconPlus } from "folksam-ui";

const styles = ({ theme }) => {
  return {
    root: {
      cursor: "pointer",
      display: "flex",
      backgroundColor: "transparent",
      alignItems: "center",
      border: "none",
      color: "#257886",
      fontFamily: theme.fonts.serif,
      fontSize: theme.textSizes.base,
      fontWeight: theme.fontWeights.semibold,
      "&:hover, &:hover $icon": {
        fill: "#31a3ae",
        color: "#31a3ae"
      }
    },
    icon: {
      fill: theme.colors.white,
      marginRight: theme.margin["2"],
      lineHeight: 0,
      borderRadius: "50%",
      backgroundColor: "#257886",
      border: "2px solid #257886"
    },
    input: {
      width: "0.1px",
      height: "0.1px",
      opacity: 0,
      overflow: "hidden",
      position: "absolute",
      zIndex: -1
    }
  };
};

const FormInputFile = React.forwardRef(
  (
    {
      classes,
      id,
      readonly,
      disabled,
      onChange,
      autoFocus,
      multiple,
      label,
      name,
      ...props
    },
    ref
  ) => {
    const inputRef = useRef(null);
    const [{ attachmentsSize }] = useFileSize();
    useEffect(() => {
      if (inputRef.current) {
        if (attachmentsSize > MAX_ATTACHMENT_SIZE)
          inputRef.current.setCustomValidity("NEEEEEEJ");
      }
    });
    return (
      <>
        <label htmlFor={id} className={classes.root}>
          <IconPlus className={classes.icon} width={16} height={16} />
          {label}
        </label>
        <input
          className={classes.input}
          id={id}
          ref={inputRef}
          name={name}
          type="file"
          disabled={readonly || disabled}
          onChange={onChange}
          defaultValue=""
          autoFocus={autoFocus}
          multiple={multiple}
        />
      </>
    );
  }
);

FormInputFile.List = FileList;

FormInputFile.propTypes = {};

export default injectSheet(styles)(FormInputFile);
